export default __webpack_public_path__ + "static/media/Siblings400.7a9e4251.jpg";